module.exports = __webpack_public_path__ + "img/bi.39f60684.jpg";